import { useState, useEffect, useCallback } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '@/integrations/supabase/client';

export const useAdminAuth = () => {
  const { user, session, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkAdminStatus = useCallback(async () => {
    if (!user || !session) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    try {
      // ✅ SEGURO: Usa função RPC is_admin() que é SECURITY DEFINER
      const { data, error } = await supabase.rpc('is_admin', {
        user_id: user.id,
      });

      if (!error) {
        setIsAdmin(data === true);
        return;
      }

      // Fallback (RLS safe): verificar diretamente na tabela user_roles
      const { data: roleData, error: roleError } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .eq('role', 'admin')
        .maybeSingle();

      if (roleError && roleError.code !== 'PGRST116') {
        setIsAdmin(false);
      } else {
        setIsAdmin(!!roleData);
      }
    } catch {
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  }, [user, session]);

  useEffect(() => {
    if (authLoading) {
      setLoading(true);
      return;
    }

    if (!user || !session) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    checkAdminStatus();
  }, [user, session, authLoading, checkAdminStatus]);

  return { isAdmin, loading };
};
